<template>
  <div class="footer-logo">
    <div class="footer-logo-img">
      <router-link to="/">
        <img src="@/assets/images/logo-empire-oc-black.png" alt="Logo" />
      </router-link>
    </div>
  </div>
</template>
  
<script>
  export default {
    name: 'FooterLogo'
  }
</script>
  
<style scoped>
  .footer-logo {
    display: flex;
    justify-content: center;
    padding-top: 64px;
    padding-bottom: 16px;
    overflow: hidden;
    width: 100%;
  }
  
  .footer-logo-img {
    width: 90px;
    position: relative;
  }
  
  .footer-logo-img::before,
  .footer-logo-img::after {
    content: "";
    height: 1px;
    width: 420px;
    background-color: #FFFFFF66;
    display: inline-block;
    position: absolute;
    top: 50%;
  }
  
  .footer-logo-img::before {
    right: 100%;
    margin-right: 12px;
  }
  
  .footer-logo-img::after {
    left: 100%;
    margin-left: 12px;
  }
</style>
